import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useFormikContext } from 'formik';
import { isEmpty } from 'lodash';
import { Loader } from 'components/common';
import {
  AuDirectionLink,
  AuTextInput
} from 'components/DTA';
import {
  ApplicationName,
  ControlInputGroup,
  FormNavigation
} from 'components/CASAForm';
import { ArnContext, FormContext } from 'contexts';
import { ArnApplicationFormData, IAddress } from 'types/forms/arnApplicationTypes';
import AddressDetails from './AddressDetails';
import { FORM_VALIDATION_ERROR_ALERT } from 'arnConstants';

const AddAddressAndContact: React.FC = (props: any) => {

  const history = useHistory();
  const { referenceDataResponse } = useContext(ArnContext);
  const { currentStepIndex, handleBack } = useContext(FormContext);
  const { values, setFieldValue, validateForm } = useFormikContext<ArnApplicationFormData>();
  const { setFormAlert, openStepById, setOnChangeValidation } = useContext(FormContext);
  const { nextStep } = props;

  const handleNext = async () => {
    // Run step validation
    const validationErrors = await validateForm();
    if (!validationErrors || isEmpty(validationErrors)) {
      setFormAlert(null);
      setOnChangeValidation(false);
      openStepById(nextStep);
    }
    else {
      if (validationErrors.address?.streetName
        || validationErrors.address?.cityOrSuburb
        || validationErrors.address?.postcode
        || validationErrors.address?.state) {
        setFieldValue('address.quickLookup', false);
      }

      if (validationErrors.postalAddress?.streetName
        || validationErrors.postalAddress?.cityOrSuburb
        || validationErrors.postalAddress?.postcode
        || validationErrors.postalAddress?.state) {
        setFieldValue('postalAddress.quickLookup', false);
      }

      setFormAlert(FORM_VALIDATION_ERROR_ALERT);
      setOnChangeValidation(true);
    }
  };

  const handleBackAction = () => {
    if (currentStepIndex == 0) {
      history.goBack();
    }

    handleBack();
  };

  const countryList = referenceDataResponse?.value && referenceDataResponse?.value['COUNTRY'].map(code => code.casa_code);

  if (!countryList || countryList.length <= 0) {
    return <Loader message='Working. Please wait.....' />;
  }

  const isPostalAddressDifferent = values.isPostalAddressDifferent;

  return (
    <>
      <ApplicationName name='Address and contact details' />
      <AuDirectionLink
        onClick={handleBackAction}
        text="Back"
        direction="left" />
      <AddressDetails
        label={'Address'}
        addressType='address' />
      <ControlInputGroup
        name='isPostalAddressDifferent'
        label='Is your postal address different to your residential address?'
        type='radio'
        block
        options={[
          {
            label: 'No',
            value: 'no'
          },
          {
            label: 'Yes',
            value: 'yes'
          }
        ]}
      />
      {isPostalAddressDifferent && isPostalAddressDifferent == 'yes' &&
        <AddressDetails
          label='Postal Address'
          addressType='postalAddress' />}
      <AuTextInput
        name='mobileNumber'
        label='Mobile number'
        as='input'
        number
        block />
      <FormNavigation
        nextButtonText='Next'
        onNextAction={handleNext}
        hidePrevious
        showSaveAndExit={false} />
    </>
  );
};

export default AddAddressAndContact;
